import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { PURGE } from "redux-persist";
import { getItemClosingStock } from "../../graphql/queries";
import moment from "moment";

const INITIAL_STATE = {
  stockSummary: [],
  dateRange: {
    period: "Today",
    timestamp: moment().unix(),
    endTimeStamp: null,
  },
  customDateModalOpen: false,
  render: true,
  loading: false,
};

// Api fetching
export const fetchOpeningStockSummary = createAsyncThunk(
  "api/opening_stock_summary",
  async (args, { getState, dispatch }) => {
    try {
      const state = getState();
      const { dateRange } = state.ItemStockReducer;

      const graphQlResponse = await API.graphql(
        graphqlOperation(getItemClosingStock, { Date: "1743379200" })
      );

      return graphQlResponse?.data?.getItemClosingStock;
    } catch (error) {
      throw error;
    }
  }
);

const itemStockSlice = createSlice({
  name: "itemStock",
  initialState: INITIAL_STATE,
  reducers: {
    setStockSummaryDateRange: (state, action) => {
      const { key, value } = action.payload;
      state.dateRange[key] = value;
      if (key === "period" && value === "custom")
        state.customDateModalOpen = true;
    },
    setCustomeDateModalOpen: (state) => {
      if (state.dateRange.endTimeStamp === null) {
        state.dateRange.period = "Today";
        state.dateRange.timestamp = moment().unix();
      }
      state.customDateModalOpen = !state.customDateModalOpen;
    },
    setItemStockSummaryReRender: (state, action) => {
      state.render = !state.render;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpeningStockSummary.fulfilled, (state, action) => {
        state.stockSummary = action.payload;
        state.render = false;
      })
      .addCase(fetchOpeningStockSummary.pending, (state, action) => {
        state.loading = true;
        state.render = false;
      })
      .addCase(fetchOpeningStockSummary.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  setStockSummaryDateRange,
  setItemStockSummaryReRender,
  setCustomeDateModalOpen,
} = itemStockSlice.actions;
export default itemStockSlice.reducer;
